export const heTr = {
  site_name: 'Visa',
  order_summary: 'מספר הזמנה',
  hotel: {
    book: 'הזמן',
  },
};
